export const GETINVENTORYLIST = 'GETINVENTORYLIST' // 获取库存信息
export const GETDATEDETAILS = 'GETDATEDETAILS' // 获取日期分布详情
export const GETLOCATIONDETAILS = 'GETLOCATIONDETAILS' // 货位明细

/**
 * 库存调整单
 */
export const GETSTOCKADJUSTPAGE = 'GETSTOCKADJUSTPAGE'
/**
 * 历史库存
 */
export const GETHISTORICALINVENTORY = 'GETHISTORICALINVENTORY' // 获取列表
export const GETGOODSHISTORYBATCH = 'GETGOODSHISTORYBATCH' // 生产日期分布明细



// WEBPACK FOOTER //
// ./src/store/inventoryManage/types.js